import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { "Content-Type": "application/json" },
});

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pergamon_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);

export const authMe = () => api.get("/auth/me").then((r) => r.data);

export const fetchContent = () => api.get("/content").then((r) => r.data);

export const saveContent = (payload) =>
  api.put("/content", payload).then((r) => r.data);

export const resetContent = () => api.post("/content/reset").then((r) => r.data);

export const listVersions = () =>
  api.get("/content/versions").then((r) => r.data);

export const restoreVersion = (id) =>
  api.post(`/content/restore/${id}`).then((r) => r.data);

export const uploadFile = (file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/uploads", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) onProgress(Math.round((evt.loaded / evt.total) * 100));
      },
    })
    .then((r) => r.data);
};

// Absolute URL from a possibly-relative /api/uploads/... path
export const absoluteMediaUrl = (url) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/")) return `${BASE}${url}`;
  return url;
};
